import service from './axios';
export const getMallCategories = (params = {}) => service.get('/manage/mall-categories', { params });
export const createMallCategory = (d) => service.post('/manage/mall-categories', d);
export const updateMallCategory = (id, d) => service.put(`/manage/mall-categories/${id}`, d);
export const deleteMallCategory = (id) => service.delete(`/manage/mall-categories/${id}`);
export const getMallProducts = (params = {}) => service.get('/manage/mall-products', { params });
export const getMallProduct = (id) => service.get(`/manage/mall-products/${id}`);
export const getMallProductsBySpu = (spuId) => service.get(`/manage/mall-products-by-spu/${spuId}`);
export const createMallProduct = (d) => service.post('/manage/mall-products', d);
export const updateMallProduct = (id, d) => service.put(`/manage/mall-products/${id}`, d);
export const deleteMallProduct = (id) => service.delete(`/manage/mall-products/${id}`);
export const getDeliverySettings = () => service.get('/manage/delivery-settings');
export const updateDeliverySettings = (d) => service.put('/manage/delivery-settings', d);
export const getCartConfig = () => service.get('/manage/cart-config');
export const setCartConfig = (d) => service.put('/manage/cart-config', d);
